import React, { useEffect, useState } from "react";
import {
  getRequest,
  postRequest,
} from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformAccountShopifyOAuthConfigurationModal = ({
  platformName,
  headers,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [selectedAdId, setSelectedAdId] = useState(""); // Selected ad ID
  const [availableAds, setAvailableAds] = useState([]); // List of ads
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSelectedData = async () => {
      try {
        const response = await getRequest(
          "/api/ads/shopify-oauth/fetch-shopify-oauth-ads",
          { ...headers }
        );

        const responseData = response.data;
        if (responseData && responseData.selected_ad_id) {
          setSelectedAdId(responseData.selected_ad_id);
        }
      } catch (err) {
        setError(
          "Failed to fetch selected Shopify OAuth ad or does not exist."
        );
      }
    };

    const fetchAvailableAds = async () => {
      try {
        const response = await getRequest(
          "/api/ads/shopify-oauth/fetch-shopify-oauth-ads",
          { ...headers }
        );

        const responseData = response.data;
        if (responseData && responseData.ads) {
          setAvailableAds(responseData.ads); // Expecting an array of ad objects
        }
      } catch (err) {
        setError("Failed to fetch Shopify ad options.");
      }
    };

    fetchAvailableAds();
    fetchSelectedData();
  }, [headers]);

  const saveShopifyOAuthAd = async () => {
    if (!selectedAdId) {
      setError("Please select a Shopify ad.");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await postRequest(
        "/api/ads/shopify-oauth/save-shopify-oauth-ad",
        { shopifyAdId: selectedAdId },
        { ...headers }
      );

      toast.success("Shopify OAuth Ads configuration updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      setError(
        "An error occurred while saving the Shopify OAuth Ads configuration."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Shopify Ad
          </label>
          <select
            value={selectedAdId}
            onChange={(e) => setSelectedAdId(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10"
          >
            <option value="" disabled>
              Select Shopify Ad
            </option>
            {availableAds.map((ad) => (
              <option key={ad.id} value={ad.id}>
                {ad.description || `Ad ${ad.id}`}{" "}
                {/* Adjust based on API response */}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="text-xs text-gray-500 italic mb-6">
        Select the Shopify ad to configure for OAuth Ads integration.
      </div>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={saveShopifyOAuthAd}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountShopifyOAuthConfigurationModal;
